// import { PencomBanner } from "@/components/banners/PencomBanner";
import { PencomCard } from "@/components/cards/PencomCard";
// import { DataTable } from "@/components/common/DataTable";
// import { type TableColumn } from "@/types";
// import { useGroupLifeInsuranceBanner } from "@/hooks/useGroupLifeInsuranceBanner";
// import { useAuthStore } from "@/stores/authStore";
// import { useMemo } from "react";

// interface CoverageBreakdownData {
//     id: string;
//     fullName: string;
//     rsaPin: string;
//     sumAssured: number;
//     coverageStatus: "Covered" | "Not Covered";
//     employmentDate: string;
// }

export const GroupLifeInsurancePage = () => {
    // const { message, hasUninsured } = useGroupLifeInsuranceBanner();
    // const { currentEmployer } = useAuthStore();

    // Generate dynamic coverage data based on current employer
    // const coverageData: CoverageBreakdownData[] = useMemo(() => {
    //     if (!currentEmployer?.employees) {
    //         return [];
    //     }

    //     return currentEmployer.employees.map((employee) => {
    //         // Determine coverage status based on employer's group life insurance compliance
    //         const isCovered = employee.has_group_life !== false && employee.gli_policy_number;

    //         return {
    //             id: employee.id.toString(),
    //             fullName: `${employee.first_name} ${employee.last_name}`,
    //             rsaPin: employee.rsa_pin,
    //             sumAssured: Math.floor(Math.random() * 50000) + 25000, // Random sum assured between 25k-75k
    //             coverageStatus: isCovered ? "Covered" : "Not Covered",
    //             employmentDate: new Date(2020 + Math.floor(Math.random() * 4), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toLocaleDateString("en-GB", {
    //                 day: "2-digit",
    //                 month: "short",
    //                 year: "numeric"
    //             })
    //         };
    //     });
    // }, [currentEmployer]);

    // Calculate provider details based on current employer
    // const providerDetails = useMemo(() => {
    //     const totalEmployees = currentEmployer?.employees?.length || 0;
    //     const coveredEmployees = coverageData.filter(emp => emp.coverageStatus === "Covered").length;
    //     const totalCoverage = coverageData
    //         .filter(emp => emp.coverageStatus === "Covered")
    //         .reduce((sum, emp) => sum + emp.sumAssured, 0);

    //     return [
    //         {
    //             label: "Provider Name",
    //             value: currentEmployer?.compliance_status === "Fully Compliant" ? "Heirs Insurance" : "Not Assigned"
    //         },
    //         {
    //             label: "Policy Number",
    //             value: currentEmployer?.compliance_status === "Fully Compliant" ? "1234567890" : "N/A",
    //         },
    //         {
    //             label: "Status",
    //             value: currentEmployer?.compliance_status === "Fully Compliant" ? "Active" : "Inactive",
    //         },
    //         {
    //             label: "Expiry Date",
    //             value: currentEmployer?.compliance_status === "Fully Compliant" ? "5th Aug, 2026" : "N/A",
    //         },
    //         {
    //             label: "Employees Covered",
    //             value: `${coveredEmployees} of ${totalEmployees} covered`
    //         },
    //         {
    //             label: "Total Coverage",
    //             value: `NGN ${totalCoverage.toLocaleString()}`,
    //         }
    //     ];
    // }, [currentEmployer, coverageData]);

    // const coverageColumns: TableColumn<CoverageBreakdownData>[] = [
    //     {
    //         key: "fullName",
    //         header: "Full Name",
    //         width: "20%",
    //     },
    //     {
    //         key: "rsaPin",
    //         header: "RSA PIN",
    //         width: "20%",
    //     },
    //     {
    //         key: "sumAssured",
    //         header: "Sum Assured",
    //         width: "15%",
    //         render: (value: unknown) => {
    //             const numValue = typeof value === "number" ? value : 0;
    //             return `₦${numValue.toLocaleString()}`;
    //         }
    //     },
    //     {
    //         key: "coverageStatus",
    //         header: "Coverage Status",
    //         width: "20%",
    //         align: "center",
    //         render: (value: unknown) => <CoverageStatusBadge status={value as "Covered" | "Not Covered"} />
    //     },
    //     {
    //         key: "employmentDate",
    //         header: "Employment Date",
    //         width: "25%",
    //     }
    // ];
    return <div className="w-full flex flex-col min-h-screen">
        <div className="w-full flex flex-col  max-w-[1240px] mx-auto mt-6">
            <h1 className="font-semibold text-2xl font-clash-display text-medium-dark-grey">Group Life Insurance</h1>
            {/* {hasUninsured && (
                <PencomBanner className="mt-10" type="warning" title={message} />
            )} */}
            <PencomCard className="mt-8" title="Provider Details">
                <div className="flex flex-row justify-between mt-6">
                    {/* {providerDetails.map((detail) => (
                        <div className="flex flex-col gap-y-1">
                            <p className="font-clash-display text-medium-dark-grey text-sm font-regular">{detail.label}</p>
                            {detail.label === "Status" ? <StatusBadge status={detail.value} /> : <p className="font-clash-display text-medium-dark-grey text-sm font-semibold">{detail.value}</p>}
                        </div>
                    ))} */}
                </div>
            </PencomCard>
            <PencomCard className="mt-8" title="Coverage Breakdown">
                {/* <DataTable
                    data={coverageData}
                    columns={coverageColumns}
                    showPagination={true}
                    currentPage={1}
                    totalPages={3}
                    onPageChange={(page) => console.log('Page changed to:', page)}
                    className="mt-6"
                /> */}
            </PencomCard>
        </div>
    </div>;
};

// const StatusBadge = ({ status }: { status: string }) => {
//     return (
//         <div className="flex flex-row gap-x-2 rounded-xl px-2 py-1 bg-light-primary-button items-center">
//             <p className="font-clash-display text-white text-xs font-medium">{status}</p>
//         </div>
//     )
// }

// const CoverageStatusBadge = ({ status }: { status: "Covered" | "Not Covered" }) => {
//     const isNotCovered = status === "Not Covered";
//     return (
//         <div className={`flex flex-row rounded-xl px-2 py-2 items-center justify-center ${isNotCovered ? "bg-red-100" : "bg-green-100"
//             }`}>
//             <p className={`font-clash-display text-xs font-medium ${isNotCovered ? "text-red-600" : "text-green-600"
//                 }`}>
//                 {status}
//             </p>
//         </div>
//     )
// }